<span class="spinner-border" id="loading" *ngIf="showLoader"></span>
<div class="container-fluid search-results-wrapper" *ngIf="toggleDashboard">
	<div style="height: calc(100% - 80px)">
		<app-custom-table [columnDefs]="columnDefs" [rowData]="readAllClientApplications" [rowSelection]="'multiple'"
			[animateRows]="true" [pagination]="true" [paginationPageSize]="10"
			(cellClicked)="onCellClicked($event)"></app-custom-table>
	</div>
</div>
<app-home-dashboard *ngIf="!toggleDashboard"></app-home-dashboard>